import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import 'primeicons/primeicons.css';

import App from './App.vue';
import { router } from './router';
import { vCan } from './directives/can';

import './styles/app.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(PrimeVue, {
  ripple: false,
  unstyled: false,
});
app.directive('can', vCan);

app.mount('#app');
